import {
  ButtonList,
  DropdownButton,
  DropdownButtonContext,
} from '@dixa/lib-shared-habla';
import type {
  SearchCompanyResult,
  SearchUserResult,
} from 'lib-shared-types-api';

import { maxResultsCount } from 'app/views/layout/views/search/utils/results/maxResultsCount';

export type Counts = Record<ContactType, number>;

type ContactType = (SearchUserResult | SearchCompanyResult)['hits_type'];

type ContactTypeDropdownProps = {
  counts: Counts;
  selected: ContactType;
  onChange: (value: ContactType) => void;
};

const getLabel = (counts: Counts, contactType: ContactType) => {
  const count = counts[contactType];

  const cappedCount =
    count >= maxResultsCount ? `${maxResultsCount}+` : count.toString();

  switch (contactType) {
    case 'company':
      return `${cappedCount} ${count === 1 ? 'company' : 'companies'}`;
    case 'user':
    default:
      return `${cappedCount} ${count === 1 ? 'contact' : 'contacts'}`;
  }
};

const CONTACT_TYPES: ContactType[] = ['user', 'company'];

/** Represents a dropdown component that is used to select a contact type */
export const ContactTypeDropdown = ({
  counts,
  selected,
  onChange,
}: ContactTypeDropdownProps): JSX.Element => {
  return (
    <DropdownButton
      buttonProps={{ variant: 'tertiary' }}
      dropdown={
        <DropdownButtonContext.Consumer>
          {({ toggleDropdown }) => (
            <ButtonList>
              {CONTACT_TYPES.map((value) => (
                <ButtonList.Item
                  key={value}
                  isSelected={value === selected}
                  onClick={() => {
                    toggleDropdown();
                    onChange(value);
                  }}
                  isDisabled={counts[value] === 0}
                >
                  {getLabel(counts, value)}
                </ButtonList.Item>
              ))}
            </ButtonList>
          )}
        </DropdownButtonContext.Consumer>
      }
    >
      {getLabel(counts, selected)}
    </DropdownButton>
  );
};
